export default __webpack_public_path__ + "static/media/avatar_xiao_mei7.8efaec96.mp3";